import { Button, Tooltip } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import moment from 'moment';
import GridContainer from '../../../GlobalComponents/Grid/GridContainer';
import GridItem from '../../../GlobalComponents/Grid/GridItem';
import EditIcon from '../../../GlobalComponents/IconComponents/EditIcon';
import ExecuteIcon from '../../../GlobalComponents/IconComponents/ExcecuteIcon';
import ViewIcon from '../../../GlobalComponents/IconComponents/ViewIcon';
import H5 from '../../../GlobalComponents/TypoGraphy/H5';
import { Colors } from '../../../GlobalComponents/Utility/Colors';
import { array_status } from '../../../ReduxTLK/features/SAV/ticketList';
import { translateCanalIndexLabel, translateDelaiIndexLabel } from '../../../utils/labelTranslator';
import StatusTicket from './StatusTicket';

export const createColumns = (handleView, handleEdit, handleExecute, isSmallScreen) => [
  {
    field: 'id',
    headerName: 'Réference',
    flex: 0.07,
    align: 'center',
    renderCell: (params) => (
      <H5 title={params?.value} fontWeight='regular' />
    ),
  },
  {
    field: 'pointDeVente',
    headerName: 'Établissement',
    flex: 0.22,
    renderCell: (params) => {


      const capitalizeFirstLetter = (text) =>
        typeof text === 'string'
          ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
          : text;

      const transformedChaine = capitalizeFirstLetter(params.row.chaine);
      let transformedPv = capitalizeFirstLetter(params.row.pointDeVente);

      if (isSmallScreen && transformedPv?.length > 15) {
        transformedPv = transformedPv.substring(0, 15) + '...';
      }

      return (
        <GridContainer alignItems="center">
          <GridItem>
            <Avatar
              sx={{ bgcolor: '#EDEDED', color: Colors.black, width: 30, height: 30 }}
            >
              {params.row?.chaine?.slice(0, 1)}
            </Avatar>
          </GridItem>

          <GridItem sx={{ ml: 2 }}>
            <H5 title={transformedChaine} fontWeight='bold' />
            <H5 title={transformedPv} color={Colors.primary} />   {/* ✅ now shortened if long */}
          </GridItem>
        </GridContainer>
      );
    },
  },

  {
    field: 'sujet',
    headerName: 'Sujet',
    flex: 0.25,
    renderCell: (params) => {
      const capitalizeFirstLetter = (text) =>
        typeof text === 'string'
          ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
          : text;

      const subject = capitalizeFirstLetter(params?.value);

      if (typeof subject === 'string' && subject.length > 50) {
        const truncated = subject.slice(0, 50) + '...';
        return (
          <Tooltip title={subject} placement="top">
            <span>{truncated}</span>
          </Tooltip>
        );
      }
      return <H5 title={subject} />;
    },
  },
  {
    field: 'date',
    headerName: 'Date Ticket',
    flex: 0.1,
    renderCell: (params) => {
      const date_creation = moment(params?.value).format("DD-MM-YYYY HH:mm");
      return <H5 title={date_creation} />;
    },
  },
  {
    field: 'assigne',
    headerName: 'Assigné à ',
    flex: 0.1,
    renderCell: (params) => <H5 title={params.row.assigne} />,
  },
  {
    field: 'Rate',
    headerName: 'Note',
    type: 'number',
    flex: 0.1,
    align: 'center',
    headerAlign: 'center',
    renderCell: (params) => (
      <H5 title={params?.row?.rate ? params?.row?.rate : '-'} />
    ),
  },
  {
    field: 'auteur',
    headerName: 'Auteur',
    flex: 0.1,
    renderCell: (params) => <H5 title={params?.row?.iUser} />,
  },
  {
    field: 'canal',
    headerName: 'Canal',
    flex: 0.1,
    renderCell: (params) => (
      <H5 title={params?.row?.canal && translateCanalIndexLabel(Number(params?.row?.canal))} />
    ),
  },
  {
    field: 'DélaiRésolution',
    headerName: 'Estimation de la résolution',
    flex: 0.1,
    renderCell: (params) => (
      <H5 title={params.row.delaiResolution && translateDelaiIndexLabel(Number(params.row.delaiResolution))} />
    ),
  },
  {
    field: 'statut',
    headerName: 'Statut',
    align: 'center',
    flex: 0.08,
    renderCell: (params) => {
      const foundStatut = array_status.find(statut => statut.id === params.row.statut);
      return <StatusTicket foundStatut={foundStatut} />;
    },
  },
  {
    field: 'action',
    align: 'center',
    headerName: '',
    flex: 0.1,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => {
      const ticket = params.row;

      const ActionButton = ({ onClick, children }) => (
        <Button
          size='small'
          sx={{ width: 5, padding: 0, minWidth: '30px', color: Colors.black }}
          onClick={onClick}
        >
          {children}
        </Button>
      );

      const View = <ActionButton onClick={() => handleView(ticket.id)}><ViewIcon /></ActionButton>;
      const Edit = <ActionButton onClick={() => handleEdit(ticket.id)}><EditIcon /></ActionButton>;
      const Execute = <ActionButton onClick={() => handleExecute(ticket.id)}><ExecuteIcon color={Colors.black} /></ActionButton>;

      return (
        <GridContainer justifyContent='center' alignItems='center' direction='row'>
          {ticket.statut === 0 && (<>{View}{Execute}</>)}
          {(ticket.statut === 1 || ticket.statut === 4) && (<>{View}{Edit}</>)}
          {ticket.statut === 6 && View}
          {![0, 1, 4, 6].includes(ticket.statut) && (<>{View}{Edit}</>)}
        </GridContainer>
      );
    },
  },
];
